import { START_INVESTMENT_STORAGE_KEY } from 'app-constants'
export const saveUserSettings = (value: any = {}) => {
  window.sessionStorage.setItem(START_INVESTMENT_STORAGE_KEY, JSON.stringify(value))
}

export const readUserSettings = (key: string, defaultValue: any) => {
  const settings = window.sessionStorage.getItem(START_INVESTMENT_STORAGE_KEY) || '{}'
  return JSON.parse(settings)[key] || defaultValue
}
